import CommonTableSection from '../../Units/Components/commonTableSection'
export default CommonTableSection
